import { atom } from 'jotai';
import { atomWithQuery } from 'jotai-tanstack-query';

import { Occupation, WorkerJPSavedResearch, WorkerSaveResearchFrequency } from '@restworld/utility-types';
import { createTaxonomyService } from '@restworld/data-services';

export type SaveResearchFrequency = WorkerSaveResearchFrequency | 'unsubscribe';

export type UserUnsubscribeReason =
  | 'already_found_work'
  | 'uninteresting_ads'
  | 'privacy_concerns'
  | 'not_looking_for_work';
export type NotificationModalState =
  | 'default'
  | 'unsubscribe'
  | 'unsubscribe_user_review'
  | 'unsubscribe_review_success'
  | 'frequency_change_success'
  | 'delete_save_research_success';
export const notificationModalToggleAtom = atom<boolean>(false);

export const notificationResearchIdAtom = atom<number>(-1);

export const notificationModalStateAtom = atom<NotificationModalState>('default');
export const notificationChangeAtom = atom<SaveResearchFrequency>('unsubscribe');
export const userUnsubscribeReasonAtom = atom<UserUnsubscribeReason | 'other' | ''>('');
export const userUnsubscribeReasonFreeTextAtom = atom<string>('');
export const saveResearchErrorReturnAtom = atom<string>('');
export const savedResearchDataAtom = atom<Partial<WorkerJPSavedResearch>>({});

export const occupationDataAtom = atomWithQuery<Occupation[]>(() => ({
  queryKey: ['occupations'],
  queryFn: async () => {
    return (
      await createTaxonomyService({
        baseUrl: process.env.NEXT_PUBLIC_BASE_API_URL,
      }).indexOccupations()
    ).data;
  },
  refetchOnWindowFocus: false,
}));
